module.exports = __webpack_public_path__ + "img/sanduIcon.b5098bdc.png";